import Vue from 'vue'
import Router from 'vue-router'
import SheetChecker from '../components/SheetChecker.vue'
import Login from '../components/Login.vue'
import Cookies from 'js-cookie'
import store from '../store/store'
import Checker from '../components/Checker.vue'
import StatusSheets from '../components/StatusSheets/StatusSheets.vue'

Vue.use(Router)

let router = new Router({
  routes: [
    {
      path: '/',
      name: 'sheetCheckerSelect',
      component: SheetChecker
    },
    {
      path: '/sheet-checker/:uuid',
      name: 'sheetChecker',
      component: Checker,
      props: true
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/status-sheets',
      name: 'StatusSheets',
      component: StatusSheets
    }
  ]
})

router.beforeEach(async function (to, from, next) {
  if ((!store.state.authorization || !store.state.userInfo) && to.path !== '/login') {
    await store.dispatch('userInfo', next)
  }

  if ((!Cookies.get('Authorization')) && to.path !== '/login') {
    store.commit('authorization', null)
    next('/login')
  } else {
    store.commit('authorization', Cookies.get('Authorization'))
    next()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js